// ===== Pinia 全局初始化 =====
// ⚠️ 此文件必须在所有使用 Pinia store 的模块之前被导入
// 只要 import 了此文件，setActivePinia 就已生效，后续所有 UserInfo() 调用都不会报错

import { createPinia, PiniaVuePlugin, setActivePinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Vue from 'vue'

// 1. 注册 Vue 2 插件
Vue.use(PiniaVuePlugin)

// 2. 创建 Pinia 实例并挂载持久化插件
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 3. 立即激活，确保所有后续的 store 调用（wechat.js、request.js、组件等）都能正常工作
setActivePinia(pinia)

export default pinia



// WEBPACK FOOTER //
// ./src/store/index.js